import { render, staticRenderFns } from "./CadastreBuildingIndexList.vue?vue&type=template&id=890874e8&scoped=true&"
import script from "./CadastreBuildingIndexList.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingIndexList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890874e8",
  null
  
)

export default component.exports